export default __webpack_public_path__ + "static/media/Amealio_Illustrations-06.a1623df2.png";